export interface VideoEpisode {
  id: string;
  title: string;
  duration: string;
}

export interface Video {
  id: string;
  title: string;
  cover: string;
  tags: string[];
  author: string;
  publishedAt: string;
  duration: string;
  description: string;
  episodes: VideoEpisode[];
}

export const videos: Video[] = [
  {
    id: 'video-001',
    title: '综艺搞笑名场面合集：这五分钟让你笑到肚子疼',
    cover: 'https://readdy.ai/api/search-image?query=playful%20tv%20show%20blooper%20scene%20with%20warm%20orange%20studio%20lights%2C%20people%20laughing%20dramatically%2C%20funny%20entertainment%20photography&width=800&height=600&seq=gaoji-video-001&orientation=landscape',
    tags: ['搞笑', '综艺剪辑', '合集'],
    author: '搞鸡视频',
    publishedAt: '2026-10-14',
    duration: '05:12',
    description: '精选近期各大综艺的高能笑点，剪成一集密集笑点合集，随手点开就会笑出声。',
    episodes: [
      { id: 'ep1', title: '名场面合集 · 上', duration: '05:12' },
      { id: 'ep2', title: '名场面合集 · 下', duration: '05:48' },
    ],
  },
  {
    id: 'video-002',
    title: '明星沙雕日常：他们私下居然是这样的',
    cover: 'https://readdy.ai/api/search-image?query=backstage%20fun%20moment%20with%20warm%20orange%20lighting%2C%20relaxed%20laughing%20people%2C%20candid%20entertainment%20photography&width=800&height=600&seq=gaoji-video-002&orientation=landscape',
    tags: ['搞笑', '明星', '日常'],
    author: '搞鸡视频',
    publishedAt: '2026-10-13',
    duration: '04:36',
    description: '镜头之外的明星们是什么样？这期带你看看他们放松又接地气的一面。',
    episodes: [
      { id: 'ep1', title: '后台花絮', duration: '04:36' },
      { id: 'ep2', title: '彩排时刻', duration: '03:52' },
      { id: 'ep3', title: '收工之后', duration: '05:04' },
    ],
  },
  {
    id: 'video-003',
    title: '脱口秀金句合集：每一句都想抄下来发朋友圈',
    cover: 'https://readdy.ai/api/search-image?query=stand%20up%20comedy%20microphone%20close%20up%20with%20warm%20orange%20spotlight%20and%20dark%20background%2C%20editorial%20photography&width=800&height=600&seq=gaoji-video-003&orientation=landscape',
    tags: ['段子', '脱口秀', '金句'],
    author: '搞鸡视频',
    publishedAt: '2026-10-12',
    duration: '06:20',
    description: '从近期脱口秀节目里挑出最扎心最好笑的金句，一次看个够。',
    episodes: [
      { id: 'ep1', title: '金句合集 · 生活篇', duration: '06:20' },
      { id: 'ep2', title: '金句合集 · 职场篇', duration: '05:30' },
    ],
  },
  {
    id: 'video-004',
    title: '魔性舞蹈挑战：跟着节奏停不下来',
    cover: 'https://readdy.ai/api/search-image?query=dance%20challenge%20scene%20with%20warm%20orange%20colorful%20neon%20lights%20and%20dynamic%20motion%2C%20energetic%20music%20video%20style&width=800&height=600&seq=gaoji-video-004&orientation=landscape',
    tags: ['搞笑', '舞蹈', '挑战'],
    author: '搞鸡视频',
    publishedAt: '2026-10-11',
    duration: '03:45',
    description: '最近爆火的魔性舞步合集，简单好学又洗脑，看完就想跟着动起来。',
    episodes: [
      { id: 'ep1', title: '挑战合集', duration: '03:45' },
    ],
  },
  {
    id: 'video-005',
    title: '萌宠搞笑时刻：它们才是真正的段子手',
    cover: 'https://readdy.ai/api/search-image?query=cute%20pets%20playing%20in%20cozy%20room%20with%20warm%20orange%20sunlight%2C%20funny%20animal%20moment%2C%20editorial%20photography&width=800&height=600&seq=gaoji-video-005&orientation=landscape',
    tags: ['搞笑', '萌宠', '治愈'],
    author: '搞鸡视频',
    publishedAt: '2026-10-10',
    duration: '05:58',
    description: '当萌宠开始整活，人类只能甘拜下风。这期全是让人忍不住循环播放的可爱瞬间。',
    episodes: [
      { id: 'ep1', title: '猫咪篇', duration: '05:58' },
      { id: 'ep2', title: '狗狗篇', duration: '06:12' },
    ],
  },
  {
    id: 'video-006',
    title: '路人采访爆笑名场面：这回答我是没想到的',
    cover: 'https://readdy.ai/api/search-image?query=street%20interview%20scene%20in%20sunny%20city%20with%20warm%20orange%20tone%2C%20microphone%20and%20smiling%20people%2C%20documentary%20photography&width=800&height=600&seq=gaoji-video-006&orientation=landscape',
    tags: ['段子', '采访', '搞笑'],
    author: '搞鸡视频',
    publishedAt: '2026-10-09',
    duration: '04:48',
    description: '街头随机采访，总能收获意想不到的神回答，笑点密集到需要暂停喘口气。',
    episodes: [
      { id: 'ep1', title: '街头采访 · 上', duration: '04:48' },
      { id: 'ep2', title: '街头采访 · 下', duration: '05:15' },
    ],
  },
  {
    id: 'video-007',
    title: '综艺翻车现场：越尴尬越想看',
    cover: 'https://readdy.ai/api/search-image?query=awkward%20funny%20tv%20studio%20moment%20with%20warm%20orange%20lights%2C%20people%20surprised%20laughing%2C%20entertainment%20photography&width=800&height=600&seq=gaoji-video-007&orientation=landscape',
    tags: ['搞笑', '综艺剪辑', '名场面'],
    author: '搞鸡视频',
    publishedAt: '2026-10-08',
    duration: '05:27',
    description: '计划赶不上变化，综艺最精彩的往往就是那些没按剧本走的瞬间。',
    episodes: [
      { id: 'ep1', title: '翻车合集', duration: '05:27' },
    ],
  },
  {
    id: 'video-008',
    title: '段子手在线开麦：两分钟告诉你什么叫语言的魅力',
    cover: 'https://readdy.ai/api/search-image?query=podcast%20recording%20studio%20with%20warm%20orange%20lighting%20and%20microphones%2C%20funny%20conversation%20scene%2C%20editorial%20photography&width=800&height=600&seq=gaoji-video-008&orientation=landscape',
    tags: ['段子', '语言类', '搞笑'],
    author: '搞鸡视频',
    publishedAt: '2026-10-07',
    duration: '02:14',
    description: '短小精悍的段子合集，用最短的时间给你最多的快乐。',
    episodes: [
      { id: 'ep1', title: '开麦合集', duration: '02:14' },
    ],
  },
  {
    id: 'video-009',
    title: '高能反转合集：结局永远猜不到',
    cover: 'https://readdy.ai/api/search-image?query=dramatic%20surprise%20moment%20with%20warm%20orange%20lighting%20and%20shocked%20faces%2C%20cinematic%20entertainment%20photography&width=800&height=600&seq=gaoji-video-009&orientation=landscape',
    tags: ['搞笑', '反转', '合集'],
    author: '搞鸡视频',
    publishedAt: '2026-10-06',
    duration: '06:02',
    description: '每一个开头都平平无奇，每一个结局都让你惊呼"还能这样"。',
    episodes: [
      { id: 'ep1', title: '反转合集 · 上', duration: '06:02' },
      { id: 'ep2', title: '反转合集 · 下', duration: '05:41' },
    ],
  },
  {
    id: 'video-010',
    title: '厨房翻车大赛：做饭这件事真的需要天赋',
    cover: 'https://readdy.ai/api/search-image?query=kitchen%20cooking%20funny%20accident%20scene%20with%20warm%20orange%20lighting%2C%20messy%20food%20preparation%2C%20playful%20editorial%20photography&width=800&height=600&seq=gaoji-video-010&orientation=landscape',
    tags: ['搞笑', '美食', '生活'],
    author: '搞鸡视频',
    publishedAt: '2026-10-05',
    duration: '04:19',
    description: '不是所有厨师都能上节目，但这些翻车现场绝对值得一个奖项。',
    episodes: [
      { id: 'ep1', title: '翻车大赛', duration: '04:19' },
    ],
  },
];